// @ts-ignore
import Quill from '@cimpress-technology/quill/core';
import { blockAttributesMapReversed } from '../attributes';

const Inline = Quill.import('blots/inline');

export class Span extends Inline {
    constructor(context, element) {
        super(context, element);

        /**
         * Since this is an Inline blot we do not expect it to have any block level attributes, but there are cases where it will inherit
         * them when Quill creates a new DOM node and looks up the attributor based on the styles/attributes and happens to find the block level one
         * first. If that happens we need to move the value from the block level attribute to the inline level attribute and clear the block level attribute.
        *
        * Example: { blockColor: 'rgb(#0000ff)', blockFontFamily: 'Satisfy' } -> { color: 'rgb(#0000ff)', fontFamily: 'Satisfy' }
        */
        const attributes = this.attributes.values();
        Object.keys(attributes).forEach((attr) => {
            if (blockAttributesMapReversed[attr]) {
                this.attributes.attribute(context.registry.types[attr], undefined);
                this.attributes.attribute(context.registry.types[blockAttributesMapReversed[attr]], attributes[attr]);
            }
        });
    }
}
